import { useQuery } from 'react-query';
import { OldChecklistParams } from './WorkorderOldChecklists.services';
import { oldChecklistDamages } from './WorkOrderOldChecklist.services';

export function useOldChecklistDamage(params: OldChecklistParams) {
  return useQuery(
    ['oldChecklist/damages', { ...params }],
    () => oldChecklistDamages(params),
    {
      enabled: !!params.diagnosticId || !!params.workOrderId,
    },
  );
}
